export default __webpack_public_path__ + "static/media/Lightsaber Luke ROTJ - Img - Wip 7_01.05a3bf38.jpg";